import { useEffect, useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Autocomplete, Button, CircularProgress, Grid, TextField, Typography } from '@mui/material';
import apiService from '../../../utlis/apiService';
import DownloadIcon from '@mui/icons-material/Download';
import { apiUrl } from '../../../config';
import { useUser } from '../../../context/userContext';
import { generateYearRange } from '../../../utlis/commonFunction';

export default function StudentProgressionReport() {
    const [data,setData] = useState([]);
    const [filterData, setFilterData] = useState({
        search: '',
        year: '',
    });
    const [totalResults, setTotalResults] = useState(0);
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 50,
        page: 0,
    });
    const [loading, setLoading] = useState(false);

    const pageOption = [10, 25, 50, 100];

    const { permissions } = useUser();
    const years = generateYearRange();

    useEffect(()=> {
        getStudentsData();
    },[filterData, paginationModel]);

    const getStudentsData = async () => {
        setLoading(true);
        try {
            const response = await apiService.get('/report/student-progression', {
                params: {
                    ...filterData,
                    page: paginationModel.page,
                    pageSize: paginationModel.pageSize,
                }
            });

            setData(response?.data?.students);
            setTotalResults(response?.data?.totalResults);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleChangeSubmit = (e, value, name) => {
        setFilterData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleChange = (name, value) => {
        setFilterData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const exportReport = async () => {
        try {
            const response = await apiService.get('/export/report/student-progression', {
                params: {
                    ...filterData,
                },
            });

            if(response?.data?.status === 'success') {
                
                window.open(`${apiUrl}${response?.data?.path}`, '_blank');
            }
        }
        catch (error) {
            console.error(error);
        }
    }

    return (
        <div style={{ height: '75vh', width: '100%' }}>
            <Typography variant="h4" gutterBottom>
                STUDENT PROGRESSION REPORT
            </Typography>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={6}>
                    <TextField
                        label="Name / Phone Number"
                        name="search"
                        value={filterData.search}
                        onChange={(e) => handleChange('search', e.target.value)}
                        fullWidth
                        size="small"
                        style={{ marginTop: 15 }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        name="year"
                        required
                        options={years}
                        style={{ marginTop: 10 }}
                        getOptionLabel={(option) => option}  
                        value={years.find((option) => option === filterData.year) || null}
                        onChange={(e, value) => handleChangeSubmit(e, value, 'year')} 
                        renderInput={(params) => <TextField {...params} label="Academic Year" />}
                        size="small"
                    />
                </Grid>
            </Grid>
            
            <Grid container spacing={2} alignItems="center" sx={{ marginBottom: 3 }}>
                <Grid item xs={4}>
                </Grid>
                <Grid item xs={8}>
                    {permissions.includes('exportStudentsReport') && (
                        <Button variant="outlined" sx={{ float: 'right' }} title="Export" onClick={exportReport}><DownloadIcon /></Button>
                    )}
                </Grid>
            </Grid>
            {loading ? (
                <div style={{ textAlign: 'center' }}>
                    <CircularProgress style={{ margin: 'auto' }} />
                </div>

            ) : (
                <DataGridPro
                    getRowId={(row) => row._id}
                    rows={data}
                    columns={[
                        { field: 'studentId', headerName: 'Student ID', flex: 1 },
                        { field: 'name', headerName: 'Name', flex: 1 },
                        { field: 'phoneNumber', headerName: 'Phone Number', flex: 1 },
                        { field: 'statusType', headerName: 'Status Type', flex: 1 },
                        { field: 'category', headerName: 'Category', flex: 1 },
                        { field: 'mode', headerName: 'Mode', flex: 1 },
                        { field: 'branch', headerName: 'Branch', flex: 1 },
                        { field: 'batchEnrolled', headerName: 'Batch Enrolled', flex: 1 },
                        { field: 'exams', headerName: 'Exams', flex: 1 },
                        { field: 'totalSubject', headerName: 'Total Subject', flex: 1 },
                        { field: 'enrolledSubject', headerName: 'Enrolled Subject', flex: 1 },
                        { field: 'totalSubjectCount', headerName: 'Total Subject Count', flex: 1 },
                        { field: 'totalenrolledBatches', headerName: 'Total Enrolled Batches', flex: 1 },
                        { field: 'totalAttendedSubject', headerName: 'Total attended Subject', flex: 1 },
                        { field: 'passCount', headerName: 'Pass', flex: 1 },
                        { field: 'failCount', headerName: 'Fail', flex: 1 },
                        { field: 'totalFee', headerName: 'Total Fee', flex: 1 },
                        { field: 'paidFee', headerName: 'Paid Fee', flex: 1 },
                        { field: 'execessFee', headerName: 'Execess Fee', flex: 1 },
                    ]}
                    pagination
                    paginationModel={paginationModel}
                    rowCount={totalResults}
                    paginationMode="server"
                    onPaginationModelChange={setPaginationModel}
                    rowsPerPageOptions={pageOption}
                />
            )}
        </div>
    );
}
